import NoMatch from 'containers/NoMatch';
import React, { useMemo } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

const Routes = ({
  routes,
}) => {
  const flattenedRoutes = useMemo(() => routes.reduce((arr, route) => {
    if (route.children) {
      arr.push(...route.children);
    }
    arr.push(route);
    return arr;
  }, []).filter(route => route.path && route.component), [routes]);

  return (
    <Switch>
      {flattenedRoutes.map(route => (
        <Route
          key={route.path}
          exact={route.exact}
          path={route.path}
        >
          <route.component {...route.props} />
        </Route>
      ))}
      <Route path="*">
        {flattenedRoutes.length > 0 ? <Redirect to={flattenedRoutes[0].path} /> : <NoMatch />}
      </Route>
    </Switch>
  );
};

export default Routes;
